'use client';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton, Typography } from '@mui/material';

import { colors } from '@/styles/theme';

interface UserMenuToggleProps {
  isAuthenticated: boolean;
  user: any;
  onClick: () => void;
  isOpen: boolean;
}

export const UserMenuToggle = ({ isAuthenticated, user, onClick, isOpen }: UserMenuToggleProps) => {
  if (isAuthenticated) {
    return (
      <Box
        onClick={onClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          cursor: 'pointer',
          '&:hover': { opacity: 0.8 },
        }}
      >
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            background: `linear-gradient(135deg, ${colors.accent.purple[500]} 0%, #e8b046 100%)`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px solid',
            borderColor: 'divider',
            flexShrink: 0,
          }}
        >
          <Typography sx={{ fontSize: '0.875rem', fontWeight: 600, color: '#ffffff' }}>
            {user?.name?.charAt(0).toUpperCase() || 'U'}
          </Typography>
        </Box>
        <KeyboardArrowDownIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
      </Box>
    );
  }

  return (
    <IconButton
      onClick={onClick}
      aria-label="Open menu"
      aria-expanded={isOpen}
      sx={{
        width: 40,
        height: 40,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        color: 'text.secondary',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <MenuIcon fontSize="small" />
    </IconButton>
  );
};
